import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';
import '@shared/styles/index.css';
import './style.css';
import App from './App.vue';
import router from './router';
import store from './store';
import config from './config';
import api from '@shared/services/api';
import { DialogService } from '@shared/services/dialogService';
Vue.use(Vuetify);
Vue.config.productionTip = false;
Vue.prototype.$config = config;
Vue.prototype.$api = api;
const vuetify = new Vuetify({ theme: { dark: true, themes: {
  dark: { primary: '#d6f34b', secondary: '#2b2b39', accent: '#d6f34b', error: '#f87171', info: '#7dd3fc', success: '#34d399', warning: '#fbbf24' },
  light: { primary: '#5b6b12', secondary: '#2b2b39', accent: '#5b6b12', error: '#b91c1c', info: '#0369a1', success: '#047857', warning: '#92400e' }
} } });
const app = new Vue({ vuetify, router, store, render: h => h(App) }).$mount('#app');
window.router = router;
DialogService.setAppInstance(app);
